<template>
  <div class="gln-actions">
    <v-btn
      icon
      small
      :disabled="isLoading"
      :title="$vuetify.lang.t('$vuetify.action.edit')"
      @click="$emit('edit')"
    >
      <v-icon small>mdi-pencil</v-icon>
    </v-btn>

    <v-btn
      icon
      small
      :disabled="!isDeletable || isLoading"
      :title="$vuetify.lang.t('$vuetify.action.delete')"
      @click="$emit('remove')"
    >
      <v-icon small>mdi-delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { canDeleteGln } from "@/helpers/gln";

export default {
  props: {
    gln: {
      type: Object,
      required: true,
    },
    loadingId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    isLoading() {
      return this.loadingId === this.gln.id;
    },
    isDeletable() {
      return canDeleteGln(this.gln);
    },
  },
};
</script>

<style scoped>
.gln-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
</style>
